import React from 'react';
export function About() {
  return <section id="about" className="py-24 bg-white" aria-labelledby="about-title" data-id="element-1">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-2">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-3">
          {/* Left: Text */}
          <div data-id="element-4">
            <p className="section-label" data-id="element-5">About Us</p>
            <h2 id="about-title" className="section-title" data-id="element-6">
              About RR Group Consulting
            </h2>

            <div className="space-y-5 text-[#6B6B6B] text-base leading-relaxed" data-id="element-7">
              <p data-id="element-8">
                RR Group Consulting is a professional consulting firm operated
                by{' '}
                <strong className="text-[#3C3C3C]" data-id="element-9">
                  Rodriguez Rangel Consulting LLC
                </strong>
                , based in Windermere, Florida, United States.
              </p>
              <p data-id="element-10">
                Our firm specializes in providing business consulting and
                technology consulting services to entrepreneurs, startups, and
                established companies.
              </p>
              <p data-id="element-11">
                We help businesses structure their operations, implement
                efficient systems, and optimize their business and technology
                infrastructure.
              </p>
            </div>

            {/* Stats row */}
            <div className="mt-10 grid grid-cols-3 gap-6 border-t border-gray-100 pt-8" data-id="element-12">
              <div data-id="element-13">
                <p className="text-3xl font-bold text-[#3A9A6A]" data-id="element-14">US</p>
                <p className="text-sm text-[#6B6B6B] mt-1" data-id="element-15">Based in Florida</p>
              </div>
              <div data-id="element-16">
                <p className="text-3xl font-bold text-[#3A9A6A]" data-id="element-17">2</p>
                <p className="text-sm text-[#6B6B6B] mt-1" data-id="element-18">Core Services</p>
              </div>
              <div data-id="element-19">
                <p className="text-3xl font-bold text-[#3A9A6A]" data-id="element-20">LATAM</p>
                <p className="text-sm text-[#6B6B6B] mt-1" data-id="element-21">Regional Reach</p>
              </div>
            </div>
          </div>

          {/* Right: Image */}
          <div className="relative" data-id="element-22">
            <img src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80" alt="Business strategy consulting meeting" className="rounded-2xl shadow-xl w-full object-cover" style={{
            aspectRatio: '4/3'
          }} data-id="element-23" />
            {/* Decorative accent */}
            <div className="absolute -bottom-4 -left-4 w-24 h-24 rounded-2xl -z-10" style={{
            backgroundColor: '#3A9A6A',
            opacity: 0.15
          }} aria-hidden="true" data-id="element-24" />
            <div className="absolute -top-4 -right-4 w-16 h-16 rounded-xl -z-10" style={{
            backgroundColor: '#3C3C3C',
            opacity: 0.08
          }} aria-hidden="true" data-id="element-25" />
          </div>
        </div>
      </div>
    </section>;
}